import Box from "@mui/material/Box";
import { useRef } from "react";
import { AboutCledarSection } from "../../components/AboutCledarSection";
import { ContactSection } from "../../components/ContactSection";
import { EnterpriseAdvantageSection } from "../../components/EnterpriseAdvantageSection";
import { HeroSection } from "../../components/HeroSection";
import { NextStepsSection } from "../../components/NextStepsSection";
import { OntologyFlywheelAdvantageSection } from "../../components/OntologyFlywheelAdvantageSection";
import { OntologySection } from "../../components/OntologySection";
import { PlatformFeaturesSection } from "../../components/PlatformFeaturesSection";
import { scrollContainerSx, stickyContainerSx } from "./Page.sx";

export default function HomePage() {
  const scrollTriggerRef = useRef<HTMLDivElement>(null);
  const aboutSectionRef = useRef<HTMLDivElement>(null);

  return (
    <>
      {/* Combined Hero + About Section - single sticky container 100vh */}
      <Box ref={scrollTriggerRef} sx={scrollContainerSx}>
        <Box sx={stickyContainerSx}>
          {/* Hero Section with Scroll Mask Animation */}
          <HeroSection
            scrollTriggerRef={scrollTriggerRef}
            aboutSectionRef={aboutSectionRef}
          />
          {/* About Cledar Section - animates up from bottom */}
          <AboutCledarSection
            scrollTriggerRef={scrollTriggerRef}
            sectionAnimRef={aboutSectionRef}
          />
        </Box>
      </Box>

      {/* Enterprise Advantage Section - sticky with fade-in animation */}
      <EnterpriseAdvantageSection />

      {/* Ontology Section - separate sticky container */}
      <OntologySection />

      {/* Platform Features & Benefits Section */}
      <PlatformFeaturesSection />

      {/* Ontology Flywheel Advantage Section */}
      <OntologyFlywheelAdvantageSection />

      {/* Next Steps Section */}
      <NextStepsSection />

      {/* Contact Section */}
      <ContactSection />
    </>
  );
}
